<template>
  <div class="combo-list">
    <div class="tuolele-main-box">
      <div class="filter-form">
        <div class="filter-top">
          <div class="form-row">
            <div class="form-input fn-clear">
              <span>学员ID（短）</span>
              <el-input
                v-model="filterObj.tll_account_id"
                size="large"
                placeholder="请输入学员ID（短）"
                @keyup.enter.native="handleEnterSearch"
              />
            </div>
            <div class="form-input">
              <span>学员ID（长）</span>
              <el-input
                v-model="filterObj.sub_id"
                size="large"
                placeholder="请输入学员ID（长）"
                @keyup.enter.native="handleEnterSearch"
              />
            </div>
            <div class="form_btn">
              <el-button type="primary" @click="searchData">查询</el-button>
            </div>
            <div class="form_btn">
              <el-button type="success" round @click="changeDetails">转换课时</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- //学员信息 -->
    <div class="table-main">
      <div v-if="subValueInfo.sub_info" class="table-body tuolele-main-box">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="学员信息" name="1">
            <div><img :src="subValueInfo.sub_info.avatar" alt="" width="100px"></div>
            <div>姓名：{{ subValueInfo.sub_info.sub_name }} <br> 学校：{{ subValueInfo.sub_info.school_name }}  <br>年级：{{ subValueInfo.sub_info.grade_name }}</div>
          </el-collapse-item>

        </el-collapse>
      </div>
    </div>
    <!-- 托乐乐课时信息 -->
    <div class="table-main">
      <div v-if="subValueInfo.tll" class="table-body tuolele-main-box">
        <span>托乐乐课时信息</span>
        <el-table
          :data="subValueInfo.tll"
          border
          stripe
          :header-cell-style="{
            background: '#4c84ff',
            color: '#fff',
            height: '60px',
            textAlign: 'center'
          }"
          @selection-change="tllHandleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          />
          <el-table-column prop="billing_id" label="合同ID" />
          <el-table-column
            prop="key_summary"
            label="课时类型"
            align="center"
          />
          <el-table-column label="总课时-已消耗课时=剩余课时">
            <template slot-scope="scope">
              {{ scope.row.days }}-{{ scope.row.consume_days }}={{ scope.row.surplus_days }}
            </template>
          </el-table-column>
          <el-table-column
            label="课时单价"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.price / 100 }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 素质学课时信息 -->
    <div class="table-main">
      <div v-if="subValueInfo.weekend" class="table-body tuolele-main-box">
        <span>素质学课时信息</span>
        <el-table
          :data="subValueInfo.weekend"
          border
          stripe
          :header-cell-style="{
            background: '#4c84ff',
            color: '#fff',
            height: '60px',
            textAlign: 'center'
          }"
          @selection-change="szxHandleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          />
          <el-table-column prop="order_id" label="合同ID" />
          <el-table-column
            prop="key_summary"
            label="课时类型"
            align="center"
          />
          <el-table-column label="总课时-已消耗课时=剩余课时">
            <template slot-scope="scope">
              {{ scope.row.days }}-{{ scope.row.consume_days }} = {{ scope.row.days-scope.row.consume_days }}
            </template>
          </el-table-column>
          <el-table-column
            label="课时单价"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.price / 100 }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 转换记录 -->
    <div class="table-main">
      <div v-if="subValueInfo.weekend" class="table-body tuolele-main-box">
        <span>转换记录</span>
        <el-table
          :data="subValueInfo.log_list"
        >
          <el-table-column prop="create_time" label="操作时间" />
          <el-table-column prop="billing_id" label="新合同ID" />
          <el-table-column prop="days" label="课时(天)" />
          <el-table-column
            label="课时总价(元)"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.price / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" />
          <el-table-column prop="editor_name" label="操作人" />
        </el-table>
      </div>
    </div>
    <!-- 自定义弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="detailsVisible"
      class="change-details"
    >
      <el-form class="fn-clear dialog_form">
        <el-form-item label="课时列表">
          <div class="table-main">
            <div v-if="original_tll.length" class="table-body ">
              <el-table
                :data="original_tll"
              >
                <el-table-column prop="billing_id" label="合同ID" />
                <el-table-column prop="key_name" label="课时类型" />
                <el-table-column prop="surplus_days" label="可转换课时" />
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.consume_days" placeholder="输入扣除课时数" @change="setOriginal(scope.row)" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-if="original_szx.length" class="table-body ">
              <el-table
                :data="original_szx"
              >
                <el-table-column prop="order_id" label="合同ID" />
                <el-table-column label="课时类型/科目">
                  <template slot-scope="scope">
                    {{ scope.row.key_name }}/{{ scope.row.subject_name }}
                  </template>
                </el-table-column>
                <el-table-column prop="surplus_days" label="可转换课时" />
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.consume_days" placeholder="输入扣除课时数" @change="setOriginal(scope.row)" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-if="original_tll.length" label="选择类型">
          <el-select v-model="target.key" placeholder="请选择">
            <el-option
              v-for="item in subValueInfo.weekend_key"
              :key="item.id"
              :label="item.key"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="original_szx.length" label="选择类型">
          <el-select v-model="target.key" placeholder="请选择课时类型">
            <el-option
              v-for="item in subValueInfo.tll_key"
              :key="item.id"
              :label="item.key"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="转换天数">
          <el-input-number v-model="target.days" :min="1" label="请输入转换天数" />
        </el-form-item>
        <el-form-item v-if="original_tll.length" label="选择科目">
          <el-select v-model="target.subject_id" placeholder="请选择科目">
            <el-option
              v-for="item in subValueInfo.weekend_subject"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="请输入备注">
          <el-input v-model="remark" type="textarea" placeholder="请输入备注" />
        </el-form-item>
        <el-button style="margin-top: 20px;" type="primary" @click="fnChangeDays">确认转换</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'OrderConvertLists',

  data() {
    return {
      dialogTitle: '', // 弹框标题
      activeNames: ['1'],
      detailsVisible: false,
      filterObj: {
        tll_account_id: '',
        sub_id: ''

      },
      subValueInfo: {}, // 学员信息及课时信息
      original_tll: [], // 托乐乐课时信息
      original_szx: [], // 素质学课时信息
      original: [], // 被扣除课时信息
      target: { 'key': '', 'days': 1, 'subject_id': '', 'remark': '' }, // 转换课时信息
      remark: ''
    }
  },
  computed: {},
  watch: {
  },
  mounted() {
  },
  methods: {
    getSubValueInfo(filterObj) {
      this.$http.getSubInfoAndValueList(filterObj).then((res) => {
        if (res.code == 200) {
          this.subValueInfo = res.data
        }
      })
    },
    searchData() {
      if (!this.filterObj.tll_account_id && !this.filterObj.sub_id) {
        this.$message.error('请输入查询ID')
        return
      }
      this.getSubValueInfo(this.filterObj)
    },
    tllHandleSelectionChange(val) {
      this.original_tll = val.map(e => {
        return { 'billing_id': e.billing_id, 'order_id': e.billing_id, 'key': e.key, 'key_name': e.key_summary, 'surplus_days': e.surplus_days }
      })
    },
    szxHandleSelectionChange(val) {
      this.original_szx = val.map(e => {
        return { 'value_id': e.value_id, 'order_id': e.order_id, 'key': e.key, 'key_name': e.key_summary, 'surplus_days': e.days - e.consume_days, 'subject_name': e.subject_name }
      })
    },
    changeDetails() {
      if (this.original_tll.length == 0 && this.original_szx.length == 0) {
        this.$message({
          message: '请选择要转换的课时',
          type: 'warning'
        })
        return
      }
      if (this.original_tll.length > 0 && this.original_szx.length > 0) {
        this.$message({
          message: '不可以同时选择两个业务类型的课时进行转换',
          type: 'warning'
        })
        return
      }
      this.original_tll.length > 0 ? this.dialogTitle = '托乐乐转-素质学' : ''
      this.original_szx.length > 0 ? this.dialogTitle = '素质学转-托乐乐' : ''
      this.detailsVisible = true
    },

    fnChangeDays() { // 提交转换
      var data = {}; var original = []
      for (var key in this.original) {
        if (this.original[key]['consume_days'] == 0) {
          continue
        }
        original.push(this.original[key])
      }
      if (!this.target.key) {
        this.$message.error('请选择课时类型')
        return
      }
      if (!this.target.subject_id && this.original_tll.length > 0) {
        this.$message.error('请选择科目')
        return
      }
      if (original.length == 0) {
        this.$message.error('扣除条目为空，请调整要扣除的课时')
        return
      }
      data.sub_id = this.subValueInfo.sub_info.sub_id
      data.original_business = this.original_tll.length > 0 ? 1 : 3 // 被转换目标
      data.target_business = this.original_tll.length > 0 ? 3 : 1 // 转换目标
      data.target_json = JSON.stringify(this.target)
      data.original_json = JSON.stringify(original)
      data.remark = this.remark

      this.$http.setChangeSubValue(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.desc,
            type: 'success'
          })
          this.detailsVisible = false
          this.searchData()
          this.subValueInfo = {} // 学员信息及课时信息
          this.original_tll = [] // 托乐乐课时信息
          this.original_szx = [] // 素质学课时信息
          this.original = [] // 被扣除课时信息
          this.target = { 'key': '', 'days': 1, 'subject_id': '' } // 转换课时信息
          this.remark = '' // 备注
        }
      })
    },
    setOriginal(v) {
      if (v.consume_days > v.surplus_days) {
        this.$message({
          message: v.order_id + ' 扣除课时不能大于可转换课时',
          type: 'warning'
        })
        return
      }
      this.original[v.order_id + '_' + v.key] = v
    },
    handleEnterSearch(e) { // 回车触发事件
      const keyCode = window.event ? e.keyCode : e.which
      if (keyCode == 13 && this.filterObj) {
        this.searchData()
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.dialog_form{
  .el-form-item{
    padding-top: 10px;
  }

}
.combo-list {
  .tuolele-main-box {
    ::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    ::v-deep .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .filter-form {
      .form-input,
      .form_btn {
        display: inline-block;
        margin-right: 20px;
      }
      .filter-body {
        padding-top: 40px;
        .el-icon-question {
          color: $color_blue;
          font-size: 18px;
          margin-left: 10px;
          cursor: pointer;
        }
        span {
          font-size: 14px;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .table-btn {
    margin-bottom: 30px;
    .el-button {
      width: 120px;
      height: 40px;
    }
  }
  ::v-deep .el-dialog {
    -webkit-backface-visibility: hidden;
    width: 620px;
    min-height: 305px;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .el-dialog__header {
      padding: 30px 35px 20px 20px;
      border-bottom: solid 1px #f5f5f5;
      .el-dialog__title {
        color: $color_blue;
        font-size: 22px;
      }
      .el-dialog__close {
        color: $color_blue;
        font-size: 20px;
      }
      .el-dialog__headerbtn {
        top: 31px;
        right: 35px;
      }
    }
    .el-dialog__body {
      padding: 30px 35px 0 30px;
      .title {
        font-size: 18px;
        color: $color_black;
        margin-bottom: 25px;
      }
      .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          color: $color_black;
          font-size: 16px;
          margin-bottom: 20px;
          width: 33%;
        }
      }
      .search-shop {
        margin-bottom: 30px;
        .el-input {
          margin-right: 20px;
        }
      }
    }
    .el-dialog__footer {
      text-align: left;
      padding-left: 30px;
      .search-shop-result {
        color: $color_black;
        font-size: 16px;
        .shop-name {
          margin-right: 60px;
        }
        p {
          font-size: 18px;
          margin-bottom: 10px;
        }
      }
    }
    .el-button {
      width: 90px;
      height: 40px;
    }
  }
}

.el-input {
  width: 180px;
}

.el-select {
  width: 180px;
}

.filter-form {
  .el-button {
    padding: 0 30px;
    height: 40px;
  }
}

.self-table {
  margin-top: 0;
  .table-name {
    height: 60px;
    background-color: $color_blue;
    opacity: 0.7;
    line-height: 60px;
    color: #fff;
    text-align: center;
    font-size: 14px;
  }
}

::v-deep .el-dialog__wrapper {
  &.change-details {
    .el-dialog {
      width: 900px;
      .el-dialog__body {
        padding: 30px 35px 30px 30px;
      }
    }
  }
}
</style>
